module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xyafvH/tc-custom/9781423661375.jpg?1736946045656",
      "alt": "This image is the cover for the book Art of the Board"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Art of the Board\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("With over 75 seasonally inspired, approachable snack boards, recipes, and cocktails, The Art of the Board has all you need for fun, stress-free entertaining year-round. Packed with tips, tricks, and ideas, you’ll be inspired to whip up your next snack board masterpiece—whether it’s creatively plating your Thanksgiving leftovers to impress your family or wowing your friends with your knowledge of fancy cheese and charcuterie. Not sure where to start? No problem! The in-depth introduction walks you through equipment and ingredients, and the Hopeless Hostess Appendix covers everything from Board Care 101 to step-by-step explanations and photographs that show how to bring your skills to the next level. There’s even helpful suggestions to make your cheese plates travel-friendly so you never arrive empty-handed. And since each board is labeled with difficulty level, approximate cost, and dietary accommodations, you’ll always find a showstopper to fit your lifestyle and budget.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Olivia Carney\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0